<template>
  <div class="position-relative">
    <b-input-group class="input-group-custom w-50 mb-3" v-if="type === 'CustomField'">
      <b-form-input
        v-model="filter.search"
        placeholder="Search Name, Type, Value"
        @keydown.enter="handleSearch"
      />
      <b-input-group-append>
        <b-button @click="handleSearch" class="search-button">
          <font-awesome-icon icon="search" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-table
      responsive
      striped
      hover
      class="table-list"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(platformId)="data">
        <img
          v-if="data.item.platformId == 1"
          src="@/assets/images/icons/line.png"
          class="mx-auto d-block"
          width="40"
        />
        <img
          v-else-if="data.item.platformId == 4"
          src="@/assets/images/icons/facebook.png"
          class="mx-auto d-block"
          width="40"
        />
        <img
          v-else-if="data.item.platformId == 5"
          src="@/assets/images/icons/instagram.png"
          class="mx-auto d-block"
          width="40"
        />
      </template>
      <template v-slot:cell(type)="data">
        <span class="text-capitalize">{{ data.item.type }}</span>
      </template>
      <template v-slot:cell(isActive)="data">
        <span v-if="data.item.isActive" class="text-success">Active</span>
        <span v-else class="text-danger">Inactive</span>
      </template>
      <template v-slot:cell(id)="data">
        <div class="d-flex justify-content-center">
          <b-link class="text-link" @click="onEdit(data.item)">
            <font-awesome-icon icon="pencil-alt" class="text-warning" title="Edit" />
          </b-link>
        </div>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col
        class="
            form-inline
            justify-content-center justify-content-sm-between
          "
      >
        <div v-if="rows > 0" class="my-auto">
          Showing {{ startPage | numeral("0,0") }} to
          {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
        </div>
        <div v-else class="my-auto">{{ rows || 0 }} entire</div>
        <div class="d-sm-flex mx-3">
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
    <ModalForm
      ref="modalForm"
      @reloadData="reloadData"
      :type="type"
      :title="title"
    />
  </div>
</template>

<script>
import ModalForm from "./ModalForm.vue";
export default {
  name: "TableList",
  props: {
    type: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    userGUID: {
      required: true,
      type: [String, Number],
    },
  },
  components: {
    ModalForm,
  },
  data: function() {
    return {
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
        userGUID: this.userGUID,
        search: "",
      },
      fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "type",
          label: "Type",
          class: "w-100px",
        },
        {
          key: "value",
          label: "Value",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
    };
  },
  created: async function() {
    await this.pagination(1);
  },
  methods: {
    getList: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/Customer/${this.type}/list`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.data;
            this.rows = data.detail.total;
          }
        })
        .catch((err) => {
          this.isBusy = false;
        });
      this.isBusy = false;
    },
    async onEdit(item) {
      let url = `/Customer/${this.type}/${item.id}`;
      if (this.type === "SystemField") url = `/Customer/${this.type}/${this.userGUID}/${item.id}`;
      
      await this.axios.get(`${this.$baseUrl}${url}`).then((data) => {
        if (data.result == 1) {
          this.$refs.modalForm.onShowModal(data.detail);
        }
      });
    },
    async handleSearch() {
      this.pagination(1);
    },
    async reloadData() {
      this.pagination(1);
      this.$emit("reloadData");
    },
    async pagination(page) {
      this.filter.pageNo = page;
      await this.getList();
      this.getShowingPage(page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
  },
};
</script>
